import { atom } from 'jotai';
import { DashboardInsights, InsightsLoadingState } from '../types/insights';

// Create atoms for storing insights data
export const insightsAtom = atom<DashboardInsights | null>(null);

// Loading state atom
export const insightsLoadingAtom = atom<InsightsLoadingState>({
  isLoading: false,
  isRefreshing: false,
  error: null,
});
